import { useState } from "react";

import Image from "next/image";

import { Notification } from "shared/components/organisms/AppNotification/components/molecules/Notification";

import { FallbackBackground, NotificationFooterImageContainer } from "./styles";

interface INotificationFooterImageProps {
  src: string;
  label: string;
  backgroundColor: string;
}

export const NotificationFooterImage = ({
  src,
  label,
  backgroundColor,
}: INotificationFooterImageProps) => {
  const [imageFailedToLoad, setImageFailedToLoad] = useState(false);

  const shouldShowImage = !imageFailedToLoad && !!src;

  return (
    <NotificationFooterImageContainer title={label}>
      {shouldShowImage ? (
        <Image
          src={src}
          alt=""
          width={28}
          height={16}
          onError={() => setImageFailedToLoad(true)}
        />
      ) : (
        !!backgroundColor && (
          <FallbackBackground backgroundColor={backgroundColor} />
        )
      )}

      <Notification.Footer.Text>{label}</Notification.Footer.Text>
    </NotificationFooterImageContainer>
  );
};
